export enum AuthenticationMethod {
    CLIENT = 'client',
    USER = 'user',
    EMAIL_CONFIRMED = 'email_confirmed',
    NONE = 'none',
}

export enum CapabilityScope {
    ATHLETE_PROFILE = 'athlete_profile',
    PLAYER_PROFILE = 'player_profile',
    RSVP = 'rsvp',
    NONE = 'none',
}

export type CapabilityToken<T extends CapabilityScope = CapabilityScope> = {
    type: T;
    token: string;
};

export const NoCapabilityToken: CapabilityToken<CapabilityScope.NONE> = {
    type: CapabilityScope.NONE,
    token: '',
};

export function isCapabilityToken<T extends CapabilityScope>(
    token: CapabilityToken<CapabilityScope>,
    type: T,
): token is CapabilityToken<T> {
    return token.type === type || token.type === CapabilityScope.NONE;
}

const PLAYER_PROFILE_RSVP = [CapabilityScope.PLAYER_PROFILE, CapabilityScope.RSVP] as const;

export const Capabilities = {
    canAccessRSVP: [CapabilityScope.RSVP],
    canAccessPlayerProfile: [CapabilityScope.PLAYER_PROFILE],
    canAccessAthleteProfileClips: [CapabilityScope.ATHLETE_PROFILE],
    canAccessAthleteProfileCareerStats: [CapabilityScope.ATHLETE_PROFILE],

    //shortcut (should mirror evaluators/team_role.ts in eden)
    canAccessTeam: PLAYER_PROFILE_RSVP,
    canAccessEvent: PLAYER_PROFILE_RSVP,
    canAccessPlaybackClip: PLAYER_PROFILE_RSVP,
} as const;
